import { render } from "./FpuiInputDate.vue?vue&type=template&id=6f07dc16&lang=pug"
import script from "./FpuiInputDate.vue?vue&type=script&lang=js"
export * from "./FpuiInputDate.vue?vue&type=script&lang=js"

import "./FpuiInputDate.vue?vue&type=style&index=0&id=6f07dc16&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__